import useProfileDetails from '@api/hooks/ambassdor/useProfileDetails'
import Layout from '@components/Common/Layout/Layout'
import AssistEarnCard from '@components/Dashboard/AssistedEarnCard/AssistedEarnCard'
import Statistics from '@components/Dashboard/Statistics/Statistics'
import GuideModal from '@components/Sales/GuideModal/GuideModal'
import GuideVideoModal from '@components/Sales/GuideVideoModal/GuideVideoModal'
import { useAmbassadorContext } from '@context/context'
import { Typography } from '@pw-tech/omni-ui'
import { PROGRAM_TYPE } from '@utils/enum'
import {
  CURRENT_STATUS,
  MY_PROFILE_DATA,
  PAGE_HEADING_DASHBOARD,
} from '@utils/translation'
import React, { useCallback, useEffect, useState } from 'react'

const CSCDashboard = () => {
  const [isOpenAssistedEarnModal, setIsOpenAssistedEarnModal] =
    useState<boolean>(false)
  const [isOpenAssistedVideoModal, setIsOpenAssistedVideoModal] =
    useState<boolean>(false)
  const [isOpenGuideModal, setIsOpenGuideModal] = useState<boolean>(false)
  const [isFirstTime, setIsFirstTime] = useState<boolean>(false)
  const { dispatch } = useAmbassadorContext()

  const { data: profileData, isFetching } = useProfileDetails()

  const renderHeading = () => {
    return (
      <div>
        <Typography variant="heading2" weight={'semi-bold'} color="#1B2124">
          {PAGE_HEADING_DASHBOARD}
        </Typography>
      </div>
    )
  }
  const updateStatus = useCallback(() => {
    const currentStatus = {
      profileStage: profileData?.profileStage,
      applicationStatus: profileData?.applicationStatus,
      ambassadorLevel: profileData?.ambassadorLevel,
      programType: profileData?.programType,
      programDetailsType: profileData?.programDetails ? true : false,
      totalPayoutCap: profileData?.totalPayoutCap,
      ...(profileData?.couponStatus && {
        couponStatus: profileData?.couponStatus,
      }),
      ...(profileData?.couponCode && {
        couponCode: profileData?.couponCode,
        couponExpiryDate: profileData?.couponExpiryDate,
        couponGenerationDate: profileData?.couponGenerationDate,
      }),
      ...(profileData?.revokeReason && {
        revokeReason: profileData?.revokeReason,
        programDetails: profileData?.programDetails,
      }),
      ...(profileData?.paymentDetails && {
        bankHolderName: profileData?.paymentDetails?.bankHolderName,
      }),
    }
    dispatch({ type: MY_PROFILE_DATA, value: currentStatus })
    localStorage.setItem(CURRENT_STATUS, JSON.stringify(currentStatus))
  }, [profileData, dispatch])

  useEffect(() => {
    if (typeof window !== 'undefined' && !isFetching && profileData) {
      updateStatus()
    }
    setIsFirstTime(true)
    dispatch({ type: 'SET_HAMBURGER_CLICK', value: 'dashboard' })
  }, [dispatch, isFetching, profileData, updateStatus])

  return (
    <Layout variant="Normal" isSidebarNeeded={false} isBackButtonNeeded={false}>
      <div className="mt-16 sm:mt-20 max-w-6xl mx-auto">
        {renderHeading()}
        <div className="mt-2 flex flex-col gap-5">
          <AssistEarnCard
            isOpenPopupCard={isOpenAssistedEarnModal}
            onClose={() => setIsOpenAssistedEarnModal(false)}
            isActive={true}
            setIsOpenGuideModal={setIsOpenGuideModal}
            setIsOpenAssistedVideoModal={setIsOpenAssistedVideoModal}
            isFirstTime={isFirstTime}
            cameFrom={PROGRAM_TYPE.CSC_PROGRAM}
          />
          <Statistics cameFrom={PROGRAM_TYPE.CSC_PROGRAM} />
        </div>

        {isOpenGuideModal && (
          <GuideModal
            isOpen={isOpenGuideModal}
            onClose={() => setIsOpenGuideModal(false)}
          />
        )}
        {isOpenAssistedVideoModal && isFirstTime && (
          <GuideVideoModal
            isOpen={isOpenAssistedVideoModal}
            onClose={() => setIsOpenAssistedVideoModal(false)}
          />
        )}
      </div>
    </Layout>
  )
}

export default CSCDashboard
